import {
  GET_PREFERENCES,
  SET_PREFERENCE,
} from '../actions/preferences';

// ------------------------------------
// Reducer
// ------------------------------------

const ACTION_HANDLERS = {
  [GET_PREFERENCES]: (state, action) => {
    const { data } = action;
    if (!data.generos || !data.dispositivos) {
      return state;
    }

    return Object.assign({}, state, data);
  },

  [SET_PREFERENCE]: (state, action) => {
    const { data } = action;
    const section = data.kind === 'genre' ? 'generos' : 'dispositivos';

    const newState = state[section].map((c, i) => {
      if (c.id !== data.id) {
        return c;
      }

      const newData = section === 'generos' ? {
        ponderacion: data.value,
        preferences: Object.keys(c.preferences).reduce((p, c) => {
          p[c] = data.name === c ? 1 : 0;
          return p;
        }, {}),
      } : {
        selected: data.value,
      };

      return Object.assign({}, c, newData)
    });

    return Object.assign({}, state, {
      [section]: newState,
    });
  },

};

const initialState = { generos: [], dispositivos: [] };

export default function reducerName(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
};
